import {
  SimpleForm,
  ArrayInput,
  SimpleFormIterator,
  Button,
  SaveButton,
  useNotify,
  useRefresh,
  RecordContextProvider,
} from "react-admin";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { MembersIteratorItem } from "server/components/Fields/MemberFields";
import { useNotifyError } from "utils/useNotifyError";

const AddMembersForm = ({ id, excludeIds = [], setAddMembersMode }) => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSave = async data => {
    const payload = { members: data.members };
    try {
      await dataProvider.customRequest(specialistRequests.addExamCommitteeMembers(id), payload, "POST");
      notify("Членовете са добавени успешно", { type: "success" });
      setAddMembersMode(false);
      refresh();
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <RecordContextProvider value={{}}>
      <SimpleForm
        toolbar={false}
        onSubmit={handleSave}
        defaultValues={{ members: [{}] }}
      >
        <ArrayInput
          source="members"
          label="Членове"
        >
          <SimpleFormIterator inline={false}>
            <MembersIteratorItem excludeIds={excludeIds} />
          </SimpleFormIterator>
        </ArrayInput>
        <Grid sx={{ display: "flex", gap: 3, mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setAddMembersMode(false)}
          />
          <SaveButton
            label="Запази"
            size="small"
            alwaysEnable
          />
        </Grid>
      </SimpleForm>
    </RecordContextProvider>
  );
};

export default AddMembersForm;
